export const styles = (theme) => ({
  root: {
    "& > *": {
      padding: "16px",
    },
  },
  headerContainer: {
    marginBottom: theme.spacing(3),
  },
  editFormWrapper: {
    padding: "32px 16px",
  },
  customCell: {
    padding: "16px",
  },
  containerImageRound: {
    position: "relative",
    borderRadius: ".25rem",
    marginRight: "1rem",
    width: "75px",
    height: "75px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    objectFit: "cover",
  },
});
